<template>
  <div class="notification-alert-schedule">
    <div v-if="internalAlerts.length" class="notification-alert-schedule-list">
      <div
        v-for="(alert, index) in internalAlerts"
        :key="index"
        class="notification-alert-schedule-row"
        :class="{ 'notification-alert-schedule-row--duplicate': isDuplicate(alert.time, alert.unit, index) }"
      >
        <span class="notification-alert-schedule-label">Notificar</span>
        <input
          type="number"
          min="1"
          v-model.number="alert.time"
          class="notification-alert-schedule-input"
        />
        <select v-model="alert.unit" class="notification-alert-schedule-select">
          <option value="minutes">Minutos</option>
          <option value="hours">Horas</option>
          <option value="days">Dias</option>
        </select>
        <span class="notification-alert-schedule-label">antes</span>
        <span v-if="isDuplicate(alert.time, alert.unit, index)" class="notification-alert-schedule-duplicate-msg">Duplicado</span>
        <button type="button" class="notification-alert-schedule-remove" @click="removeAlert(index)">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
    <div
      v-else
      class="notification-alert-schedule-empty"
      :class="{ 'notification-alert-schedule-empty--required': required }"
    >
      {{ required ? "É obrigatório configurar ao menos 1 alerta antecipado." : "Nenhum alerta configurado." }}
    </div>
    <button
      type="button"
      class="notification-alert-schedule-add"
      :disabled="internalAlerts.length >= 2"
      @click="addAlert"
    >
      <i class="fa-solid fa-plus"></i>
      Adicionar alerta
    </button>
  </div>
</template>

<script>
export default {
  name: "NotificationAlertSchedule",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalAlerts: [],
      _syncing: false,
    };
  },
  created() {
    this.internalAlerts = this.value.map((a) => ({ time: a.time, unit: a.unit }));
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        if (this._syncing) return;
        if (JSON.stringify(val) !== JSON.stringify(this.internalAlerts)) {
          this.internalAlerts = val.map((a) => ({ time: a.time, unit: a.unit }));
        }
      },
    },
    internalAlerts: {
      deep: true,
      handler(val) {
        if (val.length === 2 && val[0].time === val[1].time && val[0].unit === val[1].unit) {
          return;
        }
        this._syncing = true;
        this.$emit("input", val.map((a) => ({ time: a.time, unit: a.unit })));
        this.$nextTick(() => { this._syncing = false; });
      },
    },
  },
  methods: {
    isDuplicate(time, unit, excludeIndex) {
      return this.internalAlerts.some(
        (a, i) => i !== excludeIndex && a.time === time && a.unit === unit
      );
    },
    addAlert() {
      if (this.internalAlerts.length >= 2) return;
      const newAlert = { time: 1, unit: "days" };
      if (this.isDuplicate(newAlert.time, newAlert.unit, -1)) {
        newAlert.time = 2;
      }
      this.internalAlerts.push(newAlert);
    },
    removeAlert(index) {
      this.internalAlerts.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.notification-alert-schedule {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.notification-alert-schedule-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.notification-alert-schedule-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 7px 12px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.notification-alert-schedule-label {
  font-size: 12px;
  color: var(--text-muted);
  white-space: nowrap;
}

.notification-alert-schedule-input {
  width: 56px;
  padding: 4px 8px;
  border: 1px solid var(--border-input);
  border-radius: 8px;
  font-size: 13px;
  outline: none;
  text-align: center;
  color: var(--text-primary);
  background: var(--input-bg);
}

.notification-alert-schedule-select {
  padding: 4px 8px;
  border: 1px solid var(--border-input);
  border-radius: 8px;
  font-size: 13px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  cursor: pointer;
}

.notification-alert-schedule-remove {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--color-danger);
  font-size: 16px;
  margin-left: auto;
  transition: opacity 0.15s ease;
  display: flex;
  align-items: center;
}

.notification-alert-schedule-remove:hover {
  opacity: 0.7;
}

.notification-alert-schedule-empty {
  font-size: 12px;
  color: var(--text-muted);
}

.notification-alert-schedule-empty--required {
  color: var(--color-danger);
}

.notification-alert-schedule-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--color-brand);
  background: transparent;
  border: 1px dashed var(--color-brand-light);
  border-radius: 8px;
  padding: 5px 12px;
  cursor: pointer;
  transition: background 0.15s ease;
  width: fit-content;
}

.notification-alert-schedule-add:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.notification-alert-schedule-add:not(:disabled):hover {
  background: var(--bg-elevated);
}

.notification-alert-schedule-row--duplicate {
  border-color: var(--color-danger);
}

.notification-alert-schedule-duplicate-msg {
  font-size: 11px;
  color: var(--color-danger);
  margin-left: auto;
}
</style>
